import React, { useEffect, useState } from "react";
import Select from "react-select";
import ScrollableCalendar from './AppointmentCalendar';
import "react-calendar/dist/Calendar.css";
import "./AppointmentPage.css";
import PopUpLogIn from '../Shared/PopUpLogIn/PopUpLogIn';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const AppointmentDetailsDoctor = ({
  user,
  selectedService,
  setSelectedService,
  doctorFirstName,
  doctorLastName,
  selectedDoctor,
  setSelectedDoctor,
  drawnDoctor,
  setDrawnDoctor,

  availableDoctors,
  setAvailableDoctors,
  availableDisorders,
  setAvailableDisorders,

  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
  availableDates,
  setAvailableDates,
  availableTimes,
  setAvailableTimes,
  setServiceCost,

  serviceTimes,
  setServiceTimes,
  selectedServiceTime,
  setSelectedServiceTime,

  isPopupOpen,
  setIsPopupOpen
}) => {

  const handleLoginRegister = () => {
    setIsPopupOpen(false);
    // redirect to login/register page
    window.location.href = "/#/login"; 
  };

  const handlePopupContinue = () => {
    setIsPopupOpen(false);
  };


  const [timesAvailDoctors, setTimesAvailDoctors] = useState([]);

  const extractFields = (record, field) => {
    return [...new Set(record.map(entry => entry[field]))].sort();
  };

  // extract full names (first_name + last_name)
  const extractFullNames = (record, firstNameField, lastNameField) => {
    return [...new Set(record.map(entry => `${entry[firstNameField]} ${entry[lastNameField]}`))];
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Ensure two digits
    const day = String(date.getDate()).padStart(2, "0"); // Ensure two digits
    return `${year}-${month}-${day}`; // Return the formatted date
  };


  //communication with backend - available dates selection
  const fetchDoctor = async () => {
    const encodedFirstName = encodeURIComponent(doctorFirstName);
    const encodedLastName = encodeURIComponent(doctorLastName);

    try {
      const response = await fetch(`${API_BASE_URL}/api/doctor/getDoctorByName?firstName=${encodedFirstName}&lastName=${encodedLastName}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
    
      if (response.ok) {
        const responseDoctor = await response.json();
        setAvailableDoctors([
          {value: responseDoctor.id,
          label: `${responseDoctor.firstName} ${responseDoctor.lastName}`}
        ]);
        setSelectedDoctor({
          value: responseDoctor.id,
          label: `${responseDoctor.firstName} ${responseDoctor.lastName}`
        });

        // extract disorders joined to doctorid
        const filteredDisorders = responseDoctor.disorders
                .filter(entry => entry.isValid === true);
                
        const filteredDisordersMapped = filteredDisorders
                .map(entry => ({ 
                    value: entry.id, 
                    label: entry.name 
                    })
                );
        setAvailableDisorders(filteredDisordersMapped);

        setServiceTimes(filteredDisorders.map(entry => ({
          value: entry.id, // Value to be used internally
          label: entry.durationMinutes  // Label displayed in the dropdown
          })
        ));

        setServiceCost(filteredDisorders.map(entry => ({
          value: entry.id, // Value to be used internally
          label: entry.pricePln  // Label displayed in the dropdown
          })
        ));

      } else {
        console.error("Failed to get the doctor record!");
      }

    } catch (error) {
        console.error("Network or server error:", error);
    }
  };


  const fetchAvailableDates = async () => {
    try {
      let response;

      if (selectedDoctor.value !== 'all') {
        response = await fetch(`${API_BASE_URL}/api/doctorsAvailability/byDoctor/${selectedServiceTime}/${selectedDoctor.value}`);
      } else {
        response = await fetch(`${API_BASE_URL}/api/doctorsAvailability/byDate/${selectedServiceTime}`);
      }

      if (response && response.ok) {
          const avail_records = await response.json();
          setAvailableDates(extractFields(avail_records, 'date'));
      } else {
          console.error("Error fetching doctor availability dates.");
      }

    } catch (error) {
        console.error("Network or server error:", error);
    }
  };


  
  //communication with backend - available times selection
  const fetchAvailableTimes = async () => {
    try {
      let response;

      if (selectedDoctor.value !== 'all') {
        response = await fetch(`${API_BASE_URL}/api/doctorsAvailability/byDoctor/${selectedServiceTime}/${selectedDoctor.value}/${formatDate(selectedDate)}`);
      } else {
        response = await fetch(`${API_BASE_URL}/api/doctorsAvailability/byDate/${selectedServiceTime}/${formatDate(selectedDate)}`);
      }

      if (response.ok) {
          const avail_times = await response.json();
          
          setTimesAvailDoctors(avail_times);
          setAvailableTimes(extractFields(avail_times, 'hour'));          
      } else {
          console.error("Error fetching doctor availability dates.");
      }
    } catch (error) {
        console.error("Network or server error:", error);
    }
  };


  const handleFetchDisorders = async () => {
    return await fetchDoctor();
  };


  const fetchDisorders = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/disorder/getCurrentDisorders`);

        if (response.ok) {
            const curr_disorders = await response.json();
            setAvailableDisorders(curr_disorders.map(entry => ({
              value: entry.id, // Value to be used internally
              label: entry.name  // Label displayed in the dropdown
              })
            ));
            // console.log("availableDisorders", availableDisorders);

            setServiceTimes(curr_disorders.map(entry => ({
              value: entry.id, // Value to be used internally
              label: entry.durationMinutes  // Label displayed in the dropdown
              })
            ));

            setServiceCost(curr_disorders.map(entry => ({
              value: entry.id, // Value to be used internally
              label: entry.pricePln  // Label displayed in the dropdown
              })
            ));
            // console.log("appointmentTimes", serviceTimes);
            
            
        } else {
            console.error("Error fetching disorders.");
        }
    } catch (error) {
        console.error("Network or server error:", error);
    }
  };


  useEffect(() => {
    const init = async () => {
      if (!selectedDoctor) {
        await fetchDoctor(); // wait for result
      }

      if (selectedService && !selectedDate) {
        fetchAvailableDates();
      }

      if (selectedDate && !selectedTime) {
        fetchAvailableTimes();
      }
    };

    init();
  }, [selectedService, selectedDoctor, selectedDate]);


  // doctor change
  const handlePersonChange = (selected) => {

    setSelectedDoctor(selected);
    setSelectedDate(null); // Reset date selection when person changes
    setAvailableTimes([]); // Reset times
    setSelectedTime(null);

  };


  // service change
  const handleServiceChange = (selected) => {
  
    setSelectedService(selected);
    
    const serviceTimeDict = serviceTimes.find(service => service.value === selected.value);
    setSelectedServiceTime(serviceTimeDict.label);

    setSelectedDate(null); // Reset date selection when service changes
    setAvailableTimes([]); // Reset available times
    setSelectedTime(null); // Reset selected time

    if (selectedService) {
      fetchAvailableDates();
    }
  };



  // calendar date change
  const handleDateChange = (selected) => {

    setSelectedDate(selected);
    setSelectedTime(null); // if change the date - resete the selectedTime property

    // Update available times based on selected person and date
    if (selected) {
      fetchAvailableTimes();
    }
  };


  // time slot selection
  const handleSelectTime = (selected) => {
    setSelectedTime(selected);
  };



  return (
    <>
      <PopUpLogIn
        isOpen={isPopupOpen}
        onLoginRegister={handleLoginRegister}
        onContinue={handlePopupContinue}
      />
      <div style={{ marginTop: "1rem" }}>
        {/* for Bootstrap, p-3 translates to padding: 1rem */}
        <dir className="p-3" style={{ background: "#f8f9fa" }}>
          <div className="reservation-container">
            <h1 style={{ color: "hsl(274, 53%, 30%)", fontWeight: "bold" }}>
              Zarezerwuj termin
            </h1>
            <div className="filters" style={{ marginTop: "2rem" }}>
              
              {/* People selection */}
              <div className="filter-item">
                <h5 style={{ color: "hsl(274, 53%, 40%)" }}>
                  {selectedDoctor
                    ? `Wybrany diagnosta - ${selectedDoctor.value==='all' ? 'Wszyscy dostępni' : selectedDoctor.label}`
                    : "Diagności:"}
                </h5>
                <Select
                  options={availableDoctors}
                  value={selectedDoctor}
                  onChange={handlePersonChange}
                  placeholder="Wybierz diagnostę"
                  className="custom-select"
                  classNamePrefix="custom"
                  isSearchable={false}
                />
              </div>

              {/* Service selection */}
              {selectedDoctor && (
              <div className="filter-item">
                <h5 style={{ color: "hsl(274, 53%, 40%)" }}>
                  {selectedService
                    ? `Wybrana usługa - ${selectedService.label}`
                    : "Dostępne usługi:"}
                </h5>
                <Select
                  options={availableDisorders}
                  value={selectedService}
                  onChange={handleServiceChange}
                  placeholder="Wybierz usługę"
                  className="custom-select"
                  classNamePrefix="custom"
                  isSearchable={false}
                />
                </div>
                )}
              </div>

              {/* Calendar */}
              {selectedService && (
                <div className="calendar-container">
                  <h5 style={{ color: "hsl(274, 53%, 40%)" }}>
                    {selectedDate
                      ? `Wybrana data - ${formatDate(selectedDate)}`
                      : "Najbliższe dni:"}
                  </h5>
                  <ScrollableCalendar
                    selectedDate={selectedDate}
                    setSelectedDate={setSelectedDate}
                    selectedDoctor={selectedDoctor}
                    handleDateChange={handleDateChange}
                    availability={availableDates} // Pass availability as a prop
                  />
                </div>
              )}

            {availableTimes.length > 0 ? (
              <div className="times-container">
                <h5 style={{ color: "hsl(274, 53%, 40%)", marginTop: "2rem" }}>
                  Dostępne godziny:
                </h5>
                
                <div className="times">
                  {availableTimes.map((time, index) => (
                    <button
                      key={index}
                      className={`time-slot ${selectedTime === time ? "active" : ""}`}
                      onClick={() => handleSelectTime(time)}
                    >
                      {time.substring(0, 5)}
                    </button>
                  ))}
                </div>
              </div>
            ) : (
              selectedDoctor && (
                <p
                  style={{
                    color: "hsl(274, 53%, 40%)",
                    fontWeight: "bold",
                    fontSize: "18px",
                  }}
                >
                  Brak dostępnych terminów w tym dniu.
                </p>
              )
            )}
          </div>
        </dir>
      </div>
    </>
  );
};

export default AppointmentDetailsDoctor;
